<div mdbModal #modal="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true"
     [config]="{ignoreBackdropClick: true}" (closed)="onClosed()">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title w-100" [translate]="Localization.AddCustomCheckpoint"></h5>
        <button type="button" class="close pull-right modal-close" aria-label="Close" (click)="close()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body pt-0">
        <form *ngIf="checkpointFormGroup != null" [formGroup]="checkpointFormGroup">
          <div class="mt-4">
            <chapps-text-input
              [label]="Localization.Label"
              [control]="labelFormControl"
              [isRequired]="true"
            >
            </chapps-text-input>
          </div>
          <div class="mt-4">
            <chapps-radio-input
              [label]="Localization.CheckPointValueType"
              [control]="valueTypeFormControl"
              [items]="valueTypes"
              [isRequired]="true"
            >
            </chapps-radio-input>
          </div>
          <div class="mt-4">
            <chapps-radio-input
              [label]="Localization.IssueCategory"
              [control]="categoryFormControl"
              [items]="categories"
              [isRequired]="true"
            >
            </chapps-radio-input>
          </div>
          <div class="mt-2 d-flex justify-content-end">
            <chapps-secondary-button [loading]="isCreatingInProgress"
                                     [small]="true"
                                     [label]="Localization.CreateCustomCheckpoint"
                                     (clicked)="onCheckpointSubmit()">
            </chapps-secondary-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
